export default {
  default: {
    panel: "bg-admin_chrome border-r border-admin_bordered transition-all duration-500 ease-in-out overflow-hidden",
    panel_expanded: "",
    panel_collapsed: "",

    menu_item: "text-text hover:text-admin_primary text-left transition-all duration-300 ease-in-out",
    menu_item_expanded: "flex flex-row gap-5 text-base xl:text-lg",
    menu_item_collapsed: "flex flex-col items-center gap-2 text-sm py-2",
    menu_item_active: "text-admin_primary font-bold",

    icon_container: "flex items-center justify-center w-5 h-5 xl:w-6 xl:h-6 flex-shrink-0",
    icon_container_expanded: "w-5 h-5 xl:w-6 xl:h-6 flex-shrink-0",
    icon_container_collapsed: "w-8 h-8 flex-shrink-0",

    icon_active: "text-admin_primary",
    text_active: "text-admin_primary",
    toggle: "text-admin_neutral_2 hover:text-admin_primary bg-admin_chrome",
    toggle_top_position: "top-0",
  },
}